module.exports = __webpack_public_path__ + "img/appstore.96bb4ec8.png";